export default function (element, data) {
    const cover = element.querySelector(".cover-wrap");
    const video = element.querySelector(".video");

    cover.addEventListener("click", function () {
        cover.classList.add("hidden");
        video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

        /*
        const src = video.src;
        if (src.includes("?")) {
            video.src = src + "&autoplay=1";
        } else {
            video.src = src + "?autoplay=1";
        }
        */
    });
}
